import { FadeIn } from "@/components/FadeIn";

const personas = [
  { title: "Ehefrau oder Ehemann", desc: "Sie tragen die Rede für den Menschen, mit dem Sie ein Leben geteilt haben." },
  { title: "Tochter oder Sohn", desc: "Sie sprechen für die Familie — für das, was bleibt." },
  { title: "Trauerredner:in", desc: "Sie suchen einen ersten Ausgangspunkt, den Sie professionell weiterführen." },
  { title: "Freund:in", desc: "Sie sprechen zur Familie — über das, was diese Freundschaft ausgemacht hat." },
  { title: "Kolleg:in", desc: "Sie würdigen einen Menschen, der das Arbeitsleben vieler geprägt hat." },
];

export default function ForWhom() {
  return (
    <section className="py-24 md:py-36">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <FadeIn>
          <p className="label-eyebrow mb-6">Für wen</p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-charcoal max-w-3xl leading-[1.1]">
            Für jeden, der Worte für einen geliebten Menschen sucht.
          </h2>
        </FadeIn>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {personas.map((p, i) => (
            <FadeIn key={p.title} delay={0.05 * i}>
              <div
                data-testid={`persona-card-${i}`}
                className="h-full bg-paper rounded-2xl p-8 shadow-card hover:shadow-cardHover hover:-translate-y-1 transition-all duration-500"
              >
                <div className="font-display tracking-[0.25em] text-[10px] text-umber mb-4">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="font-serif text-2xl text-charcoal mb-3">{p.title}</h3>
                <p className="font-serif text-base text-ink leading-relaxed">{p.desc}</p>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
